function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "trash",
  d: "M5.287,5.362H7.65V4.575A1.575,1.575,0,0,1,9.225,3H13.95a1.575,1.575,0,0,1,1.575,1.575v.787h2.362a.788.788,0,1,1,0,1.575H17.1V17.175a1.575,1.575,0,0,1-1.575,1.575H7.65a1.575,1.575,0,0,1-1.575-1.575V6.938H5.287a.788.788,0,0,1,0-1.575ZM7.65,6.938V17.175h7.875V6.938ZM9.225,5.362H13.95V4.575H9.225Zm0,3.15H10.8V15.6H9.225Zm3.15,0H13.95V15.6H12.375Z",
  transform: "translate(-4.5 -3)",
  fill: "#a0a0a0"
});
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.175,
    height: 15.75,
    viewBox: "0 0 14.175 15.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.f2a891c2.svg";
export { ForwardRef as ReactComponent };